import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=10a75a65&scoped=true"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=10a75a65&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a75a65",
  null
  
)

/* custom blocks */
import block0 from "./loading.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports